import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ErrorComponent } from '../../shared/Components/error/error.component';
import { AuthService } from '../../shared/services/auth.service.service';

@Component({
  selector: 'debtor-panel-technical-error',
  templateUrl: './technical-error.component.html',
  styleUrls: ['./technical-error.component.scss'],
  imports: [RouterModule, ErrorComponent],
})
export class TechnicalErrorComponent {
  constructor(private router: Router, private authService: AuthService) {}

  protected handleReload(): void {
    this.authService.login();
    // this.router.navigate(['/']);
  }
}
